var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-tabs',{attrs:{"dark":""}},[_c('v-tab',{key:"accommodation",attrs:{"to":"accommodations"}},[_vm._v("Accommodations")]),_vm._v(" "),_c('v-tab',{key:"addons",attrs:{"to":"addons"}},[_vm._v("Addons")])],1),_vm._v(" "),_c('router-view')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10792595","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ski/skistar/SkistarResortWrapper.vue
// module id = null
// module chunks = 